import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuthContext } from '../../services/AuthService';
import { buildLoginRedirect } from './authRedirect';
import { getForceLoginEnabled } from './googleAuthConfig';

export const FORCE_LOGIN_PUBLIC_PATHS = new Set([
    '/login',
    '/signup',
    '/reset_password',
    '/logout',
]);

const ForceLoginGate = ({ children }) => {
    const auth = useAuthContext();
    const location = useLocation();
    const shouldForceLogin = getForceLoginEnabled();

    if (
        shouldForceLogin
        && !auth.state.isAuthenticated
        && !FORCE_LOGIN_PUBLIC_PATHS.has(location.pathname)
    ) {
        return <Navigate to={buildLoginRedirect(location)} replace state={{ from: location }} />;
    }

    return children;
};

export default ForceLoginGate;
